import { actionTypes } from "../actions/auth";
import moment from 'moment';

let sessionUser = JSON.parse(localStorage.getItem('auth'))

const now = moment();
if (sessionUser && moment(sessionUser.expires).isBefore(now)) {
  localStorage.setItem('auth', null);
  sessionUser = null;
}

const initialState = sessionUser || null

const authReducer = (state = initialState, action) => {
  let newState = state;
  switch (action.type) {
    case actionTypes.SET_USER: {
      newState = action.payload;
      break;
    }
    default: {
      newState = state;
      break;
    }
  }
  if (newState) {
    localStorage.setItem('auth', JSON.stringify(newState));
  } else {
    localStorage.removeItem('auth')
    localStorage.clear('multistore', false);
    localStorage.clear('multistore:selectedStore');
    localStorage.clear('multistore:stores');
  }
  return newState
};

export default authReducer;
